if (!window.TdBodyScrollLock) {
  window.TdBodyScrollLock = (() => {
    const datasetKeys = {
      count: "tdScrollLockCount",
      scrollY: "tdScrollY",
      prevPosition: "tdPrevPosition",
      prevTop: "tdPrevTop",
      prevLeft: "tdPrevLeft",
      prevRight: "tdPrevRight",
      prevWidth: "tdPrevWidth",
      prevOverflow: "tdPrevOverflow",
      prevScrollBehavior: "tdPrevScrollBehavior",
    };

    function lock(body) {
      if (!body) return;

      const lockCount = Number(body.dataset[datasetKeys.count] || 0);

      if (lockCount === 0) {
        const scrollY = window.scrollY || window.pageYOffset || 0;

        body.dataset[datasetKeys.scrollY] = String(scrollY);
        body.dataset[datasetKeys.prevPosition] = body.style.position || "";
        body.dataset[datasetKeys.prevTop] = body.style.top || "";
        body.dataset[datasetKeys.prevLeft] = body.style.left || "";
        body.dataset[datasetKeys.prevRight] = body.style.right || "";
        body.dataset[datasetKeys.prevWidth] = body.style.width || "";
        body.dataset[datasetKeys.prevOverflow] = body.style.overflow || "";
        body.dataset[datasetKeys.prevScrollBehavior] =
          document.documentElement.style.scrollBehavior || "";

        body.style.position = "fixed";
        body.style.top = `-${scrollY}px`;
        body.style.left = "0";
        body.style.right = "0";
        body.style.width = "100%";
        body.style.overflow = "hidden";
      }

      body.dataset[datasetKeys.count] = String(lockCount + 1);
    }

    function unlock(body) {
      if (!body) return;

      const lockCount = Number(body.dataset[datasetKeys.count] || 0);
      if (lockCount <= 0) return;

      if (lockCount > 1) {
        body.dataset[datasetKeys.count] = String(lockCount - 1);
        return;
      }

      const scrollY = Number(body.dataset[datasetKeys.scrollY] || 0);
      const previousScrollBehavior = body.dataset[datasetKeys.prevScrollBehavior] || "";

      body.style.position = body.dataset[datasetKeys.prevPosition] || "";
      body.style.top = body.dataset[datasetKeys.prevTop] || "";
      body.style.left = body.dataset[datasetKeys.prevLeft] || "";
      body.style.right = body.dataset[datasetKeys.prevRight] || "";
      body.style.width = body.dataset[datasetKeys.prevWidth] || "";
      body.style.overflow = body.dataset[datasetKeys.prevOverflow] || "";
      document.documentElement.style.scrollBehavior = "auto";

      delete body.dataset[datasetKeys.count];
      delete body.dataset[datasetKeys.scrollY];
      delete body.dataset[datasetKeys.prevPosition];
      delete body.dataset[datasetKeys.prevTop];
      delete body.dataset[datasetKeys.prevLeft];
      delete body.dataset[datasetKeys.prevRight];
      delete body.dataset[datasetKeys.prevWidth];
      delete body.dataset[datasetKeys.prevOverflow];
      delete body.dataset[datasetKeys.prevScrollBehavior];

      window.scrollTo({ top: scrollY, left: 0, behavior: "auto" });
      window.requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = previousScrollBehavior;
      });
    }

    return {
      lock,
      unlock,
    };
  })();
}
